// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "call_window_job_cap.proto" (syntax proto3)
// tslint:disable
import { CallWindowJobCapService } from "./call_window_job_cap";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service CallWindowJobCapService
 */
export class CallWindowJobCapServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = CallWindowJobCapService.typeName;
        this.methods = CallWindowJobCapService.methods;
        this.options = CallWindowJobCapService.options;
    }
    /**
     * @generated from protobuf rpc: CreateCallWindowJobCap
     */
    createCallWindowJobCap(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCallWindowJobCap
     */
    getCallWindowJobCap(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetCallWindowJobCap
     */
    batchGetCallWindowJobCap(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCallWindowJobCap
     */
    updateCallWindowJobCap(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteCallWindowJobCap
     */
    deleteCallWindowJobCap(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
